import {
  OAuthProvider,
  signInWithPopup,
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";

import { firebaseAuthenticationAPIErrors } from "./firebase-errors";
import { app } from "./firebase-config";

const auth = getAuth(app);

export async function firebaseGoogleSignin() {
  const data = {
    error: false,
    detail: {},
  };

  try {
    const provider = new GoogleAuthProvider();
    const res = await signInWithPopup(auth, provider);
    data.error = false;
    data.detail = res.user;
  } catch (error) {
    const errorMessage = error.message;
    data.error = true;
    data.detail = firebaseAuthenticationAPIErrors[errorMessage] || "Unexpected error occurred!";
  }

  return data;
}

export async function firebaseGithubSignin() {
  const data = {
    error: false,
    detail: {},
  };

  try {
    const provider = new GithubAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account",
    });
    const res = await signInWithPopup(auth, provider);
    data.error = false;
    data.detail = res.user;
  } catch (error) {
    const errorMessage = error.message;
    data.error = true;
    data.detail = firebaseAuthenticationAPIErrors[errorMessage] || "Unexpected error occurred!";
  }

  return data;
}

export async function firebaseFacebookSignin() {
  const data = {
    error: false,
    detail: {},
  };

  try {
    const provider = new FacebookAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account",
    });
    const res = await signInWithPopup(auth, provider);
    data.error = false;
    data.detail = res.user;
  } catch (error) {
    const errorMessage = error.message;
    data.error = true;
    data.detail = firebaseAuthenticationAPIErrors[errorMessage] || "Unexpected error occurred!";
  }

  return data;
}

export async function firebaseMicrosoftSignin() {
  const data = {
    error: false,
    detail: {},
  };

  try {
    const provider = new OAuthProvider("microsoft.com");
    provider.setCustomParameters({
      prompt: "select_account",
    });
    const res = await signInWithPopup(auth, provider);
    data.error = false;
    data.detail = res.user;
  } catch (error) {
    const errorMessage = error.message;
    data.error = true;
    data.detail = firebaseAuthenticationAPIErrors[errorMessage] || "Unexpected error occurred!";
  }

  return data;
}
